import "./TermsConditions.module.css";
import Header from "@/reusable_sections/Header";
import TermsContent from "./sections/TermsContent";
import ContactPrompt from "./sections/ContactPrompt";
import Footer from "@/reusable_sections/Footer";
export default function TermsConditionsPage() {
  return <div>
      <Header />
      <TermsContent />
      <ContactPrompt />
      <Footer />
    </div>;
}